import React from 'react'
import styles from './documentos.module.scss'
import { t, textWithLocale } from '../../../../../common/i18n'
import SectionWithHeading from '../../../../components/SectionWithHeading/SectionWithHeading'
import PDFIcon from './assets/pdf-icon.svg'
import DownIcon from './assets/download-icon.svg'

export type Documento = {
  url_es: string
  url_pt: string
  url_ca: string
  nombre_es: string
  nombre_pt: string
  nombre_ca: string
}

interface Props {
  documents: Array<Documento>
}

export const Documentos: React.FC<Props> = ({ documents }) => (
  <SectionWithHeading
    title={t('catalogo.producto.ficha.section_documentos.title')}>
    <div className={styles.documents}>
      <dl className={styles.documents__list}>
        {documents.map((doc, index) => (
          <div key={index} className={styles.document__item}>
            {/* PDF Icon */}
            <PDFIcon />

            {/* Document Name */}
            <dt className={styles.document__name}>
              {doc[textWithLocale('nombre')]}
            </dt>

            {/* Download Icon */}
            <a
              href={doc[textWithLocale('url')]}
              target="_blank"
              rel="noopener noreferrer"
              download>
              <DownIcon />
            </a>
          </div>
        ))}
      </dl>
    </div>
  </SectionWithHeading>
)
